class NodeTranslationService extends BaseService
	@register()

	initialize: ->
		@id = 'id'
		@name = 'name'
		@parentIndicator = 'parentId'

	translate: (elements, parent = null) ->
		out = []

		for element, index in elements
			element.expanded ?= false

			if element.parent_id == parent
				children = @translate(elements, element.id)

				if children.length
					element.children = children

				out.push element
		return out

	configure: (config) ->
		@id = config.id
		@name = config.name
		@parentIndicator = config.parentIndicator
